import React from 'react';
import styles from '../scss/CustomFields.module.scss.js';

// interface Props {
//     fields: React.ReactNode[]
//     linkColor: string
// }

var CustomFields = function CustomFields(_ref) {
  var _ref$fields = _ref.fields,
    fields = _ref$fields === void 0 ? [] : _ref$fields,
    _ref$linkColor = _ref.linkColor,
    linkColor = _ref$linkColor === void 0 ? '' : _ref$linkColor;
  return /*#__PURE__*/React.createElement("div", {
    className: styles.container
  }, fields.map(function (Field, idx) {
    return /*#__PURE__*/React.createElement(Field, {
      key: idx,
      linkColor: linkColor
    });
  }));
};
var MemoizedCustomFields = /*#__PURE__*/React.memo(CustomFields);
MemoizedCustomFields.displayName = 'FieldSignupCustomFields';
var CustomFields$1 = MemoizedCustomFields;

export { CustomFields, CustomFields$1 as default };
//# sourceMappingURL=index.js.map
